import { useAccount, useMsal } from '@azure/msal-react';
import { getBusinessUnitsFromRoles, mapRoles, Role } from './use-permissions.hook.core';

export const usePermissions = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const roles = account?.idTokenClaims?.roles || [];
  const mappedRoles = mapRoles(roles);

  return {
    isAuthenticated: !!account,
    roles: mappedRoles,
    isAdmin: mappedRoles.includes(Role.Admin),
    consumerBusinessUnits: getBusinessUnitsFromRoles(roles, 'consumer'),
    maintainerBusinessUnits: getBusinessUnitsFromRoles(roles, 'maintainer'),
  };
};
